import React from "react";
import Header from "./Header";
import ImageLightboxGallery from "./ImageLightboxGallery";
import IntroSection from "./IntroSection";
import { useGalleryFeed } from "../hooks/useSyncedImages";
import GalleryLoadMore from './GalleryLoadMore';

export default function EventGalleryPage({ intro, images, imageLabel, cloudinaryFolder }) {
  const feed = useGalleryFeed(cloudinaryFolder, images);
  return (
    <div className="font-serif">
      <Header />
      <IntroSection {...intro} />
      <ImageLightboxGallery images={feed.items} imageLabel={imageLabel} />
      {!feed.items.length && cloudinaryFolder && (
        <p className="text-center pb-8 text-gray-600">
          {feed.loading ? 'Loading photos…' : feed.error ? 'Photos are temporarily unavailable.' : 'No photos are available yet.'}
        </p>
      )}
      <GalleryLoadMore feed={feed} />
    </div>
  );
}
